module.exports = __webpack_public_path__ + "img/image-style-09.e0e5e0ac.svg";